import React, { useContext } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { StoreContext } from "../../store/Store";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const { userid } = useContext(StoreContext);
  const location = useLocation()
  return (
    <>
      <footer
        className="Z-99 position-realtive"
        style={{
          backgroundColor: "#fff",
          borderTop: "1px solid #d9e1e6",
          padding: "20px 10px",
        }}
      >
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-sm-6">
              <p className="mb-0">
                © 2026 CXOBox.AI | All rights reserved.{" "}
                {/* © 2026 {userid && (userid == 132 ? "Cloocus" : "VIZI 360")} {location.pathname == "/sign-in" ? "VIZI 360" : ""} | All
                rights reserved.{" "} */}
              </p>
            </div>
            <div className="col-sm-6 d-flex justify-content-end align-items-center">
              {/* <button
                type="button"
                className="border rounded-5 d-flex align-items-center gap-1"
                style={{
                  fontSize: "15px",
                  backgroundColor: "#f8f8f8",
                  borderColor: "#00000026",
                  padding: "6px 12px",
                }}
                id="modal_h"
              >
                <Icon icon="mdi:help-circle-outline" className="icon" />
                <span>Help</span>
              </button> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
